import { protectedResources } from '@/authConfig';
import acquireAccessToken from '@/http/Helpers/acquireAccessToken';
import { applyPlaygroundModeHeader } from '@/http/Helpers/playgroundModeHeader';
import {
  handleApiResponse,
  rememberRequestBody
} from '@/http/OpenAPI/clients/staleClaimRetry';
import * as Sentry from '@sentry/browser';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';

import { paths } from '../../types/coi';

const { logger } = Sentry;

// COI is secured (US-16 / #6718): its controllers require the signed-in B2C
// access token, so — like every other client in this folder — attach an MSAL
// bearer token on each request via the shared coiWebApi scope.
const scopes = protectedResources.coiWebApi.scopes;

const fetchClient = createFetchClient<paths>({
  baseUrl: protectedResources.coiWebApi.endpoint
});

fetchClient.use({
  onRequest: async (req) => {
    try {
      const token = await acquireAccessToken(scopes);
      req.request.headers.set('Authorization', `Bearer ${token}`);
      applyPlaygroundModeHeader(req.request);
      // Buffer the body while it is still readable — a 403 replay cannot clone a Request
      // that fetch has already consumed (ADO #7699).
      await rememberRequestBody(req.request);
    } catch {
      // Do nothing
    }
  },
  onResponse: (ctx) => handleApiResponse(ctx, { api: 'coi', scopes }),
  onError: async (err) => {
    logger.error('Error occurred in COI fetch client', {
      error: err,
      api: 'coi'
    });
  }
});

export const $coiApi = createClient(fetchClient);

export { fetchClient as coiOpenApiClient };
